export default "__VITE_ASSET__DQVpJrEa__"